module.exports = __webpack_public_path__ + "ath_game_web/img/6.2.5e16d159.png";